import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { PageHeader, EmptyState } from '@/components/Shared';
import { dateTime } from '@/lib/format';
import { ScrollText } from 'lucide-react';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/audit').then(({ data }) => setLogs(data)); }, []);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Complete record of all system actions" testid="audit-header" />
      <Card className="p-0 overflow-hidden">
        {logs.length === 0 ? <div className="p-6"><EmptyState icon={ScrollText} title="No activity yet" /></div> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Details</TableHead><TableHead className="text-right">Qty</TableHead></TableRow></TableHeader>
              <TableBody>
                {logs.map((l) => (
                  <TableRow key={l.id} data-testid="audit-log-row">
                    <TableCell className="text-sm whitespace-nowrap">{dateTime(l.created_at)}</TableCell>
                    <TableCell>{l.user_name}</TableCell>
                    <TableCell><span className="font-mono text-xs">{l.action}</span></TableCell>
                    <TableCell className="capitalize">{l.entity}</TableCell>
                    <TableCell className="text-sm text-muted-foreground">{l.details}</TableCell>
                    <TableCell className="text-right tabular-nums">{l.quantity ?? '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
